<div class="dahboard-management">
  <app-select-site
    class="h-100 w-100"
    *ngIf="this.sharedData?.selectedSite?.siteId === ''; else userDetail"
  >
  </app-select-site>

  <ng-template #userDetail>
    <div class="container-fluid">
      <div class="user-management">
        <a class="btn-back" routerLink="/dashboard">
          <p class="pointer-cursor ml-5 pl-1 pt-12" (click)="navigateBack()">
            {{ 'BACK_BUTTON' | translate }}
          </p>
        </a>
        <div
          class="mt-0 row h-100 my-lg-5 mx-lg-5 mx-xl-5 mx-xl-5 my-md-3 mx-md-3 my-sm-2 mx-sm-2 my-xs-1 mx-xs-1"
        >
          <app-shared-user-list
            class="col-12 col-xl-4 col-mt-5 pr-lg-3 pr-xl-3 mb-md-5"
          ></app-shared-user-list>
          <!-- adding router outlet for child routes -->
          <div class="col-12 col-xl-8 col-mt-5 pl-lg-3 pl-xl-3 mb-md-5">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
